var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoFooter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "T_favicon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.716,
    height: 32.995,
    viewBox: "0 0 27.716 32.995",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "T_favicon-2",
    "data-name": "T_favicon",
    d: "M47.559,21.777h-6.6v-6.6h6.6ZM40.96,0V11.218h1.98v-.33c0-5.279,2.97-8.579,8.579-8.579h.33V26.066c0,3.3-1.32,4.619-4.619,4.619h-.99V33H63.4v-2.31h-.99c-3.3,0-4.619-1.32-4.619-4.619V2.31h.33c5.609,0,8.579,3.3,8.579,8.579v.33h1.98V0ZM62.077,21.777h6.6v-6.6h-6.6Z",
    transform: "translate(-40.96)",
    fill: "#e20074"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFooter);
export default __webpack_public_path__ + "static/media/logo-footer.b3dbaaefd19bb2445eeedc7ee338cb5e.svg";
export { ForwardRef as ReactComponent };